import Text from 'components/shared/Text'
import Section from 'components/shared/Section'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from 'components/shared/Link'
import Box from 'components/shared/Box'
import PersonTypePicker from 'routes/unlimited-card/CardConfiguration/UnlimitedCardConfigurator/PersonTypePicker'
import { useEffect } from 'react'
import { useAutoScroll } from 'utils/hooks'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { removeVoucher, setVoucherPerson } from 'store/vouchers-slice'
import { CardPersonDto } from 'store/api-slice/hooks'
import VoucherCardTypePicker from 'routes/vouchers/VouchersConfiguration/VoucherCardTypePicker'
import PersonalisedVoucher from 'routes/vouchers/VouchersConfiguration/PersonalisedVoucher'

interface CardVoucherConfigurationProps {
    index: number
    isEraseable?: boolean
}

const CardVoucherConfiguration = ({
    index,
    isEraseable = true,
}: CardVoucherConfigurationProps) => {
    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const { calculateScroll, animatePendingScroll, scrollIndex } =
        useAutoScroll()

    const { vouchersBoxes } = useAppSelector((state) => state.vouchers)
    const { personDetail, productId } = vouchersBoxes[index]
    const chosenPersonType = personDetail?.key

    const sectionId = `voucher-${index}`

    const handleRemoveVoucher = () => dispatch(removeVoucher(index))

    const handleSetPersonType = (personDetail: CardPersonDto) => {
        dispatch(setVoucherPerson({ index, personDetail }))
        calculateScroll({
            trigerringSection: 'vouchers_configuration',
            trigerringAction: 'choose_type',
            targetId: `card_type-${index}`,
        })
    }

    useEffect(() => {
        animatePendingScroll(sectionId)
    }, [scrollIndex])

    return (
        <Section id={sectionId}>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                mb={[32, 64]}
            >
                <Text variant="heading2" color="grayscale_900">
                    <FormattedMessage
                        id="vouchers.config.item_caption"
                        defaultMessage="Voucher"
                    />{' '}
                    {index + 1}
                </Text>

                {isEraseable && (
                    <Link
                        variant="secondary"
                        icon="bin"
                        onClick={handleRemoveVoucher}
                    >
                        <FormattedMessage
                            id="global.btn.remove"
                            defaultMessage="Usuń"
                        />
                    </Link>
                )}
            </Box>

            <PersonTypePicker
                index={index}
                title={formatMessage({
                    id: 'vouchers.config.card_item_choose_type_caption',
                    defaultMessage: 'Wybierz typ karty',
                })}
                selectedPerson={chosenPersonType}
                setPerson={handleSetPersonType}
                testIdPrefix="voucher"
            />

            {chosenPersonType && (
                <VoucherCardTypePicker
                    index={index}
                    personType={chosenPersonType}
                />
            )}

            {!!productId && <PersonalisedVoucher index={index} />}
        </Section>
    )
}

export default CardVoucherConfiguration
